import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseSectionComponent } from '../base-section.abstract';
import { ZeroColumnComponent } from '../../columns/zero-column/zero-column.component';

@Component({
    selector: 'web-zero-section',
    templateUrl: './zero-section.component.html',
    styleUrls: ['./zero-section.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ZeroColumnComponent],
})
export class ZeroSectionComponent extends BaseSectionComponent {}
